import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { ProgrammeCard, ProgrammeDirectories } from './programme-model';

@Injectable()
export class ProgrammeServiceService {

  constructor(private http: HttpClient,
    private auth: AuthenticationService,) { }

  getProgrammeCards() {
    return this.http.get<ProgrammeCard[]>(`${this.auth.apiUrl}/api/learning-statistics/programmes-stats`, {
      headers: this.auth.header,
      params: new HttpParams().set('t', Date.now().toString())
    });
  }

  getProgrammeUsers(id: number) {
    return this.http.get<ProgrammeCard[]>(`${this.auth.apiUrl}/api/learning-statistics/users/${id}`, {
      headers: this.auth.header,
      params: new HttpParams().set('t', Date.now().toString())
    });
  }

  getDirectories() {
    return this.http.get<ProgrammeDirectories[]>(`${this.auth.apiUrl}/api/learning-statistics/analytics/directories`, {
      headers: this.auth.header,
      params: new HttpParams().set('t', Date.now().toString())
    });
  }

  getDocumentHours(parentId: number) {
    return this.http.get<any[]>(`${this.auth.apiUrl}/api/learning-statistics/analytics/document-hours/${parentId}`,
      {
        headers: this.auth.header,
        params: new HttpParams().set('t', Date.now().toString())
      }
    );
  }

  getTotalCompleted(parentId: number) {
    return this.http.get<number>(`${this.auth.apiUrl}/api/learning-statistics/analytics/document-completed/${parentId}`);
  }

  getUserContentWatchReport(parentId: number) {
   return this.http.get<any[]>(`${this.auth.apiUrl}/api/learning-statistics/analytics/user-content-watch/${parentId}`);
  }

  getTopContentWatchReport(filter: any) {
    return this.http.post<any[]>(`${this.auth.apiUrl}/api/learning-statistics/analytics/top-content-watch`,filter );
  }

  getClients() {
    return this.http.get<ProgrammeDirectories[]>(`${this.auth.apiUrl}/api/learning-statistics/analytics/clients`);
  }

  getTopUserEngagement(filter: any) {
    return this.http.post<any[]>(`${this.auth.apiUrl}/api/learning-statistics/analytics/top-user-engagement`,filter );
  }

  getEngagementSummary(filter: any) {
    return this.http.post<any>( `${this.auth.apiUrl}/api/learning-statistics/analytics/engagement-summary`,filter );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/programme-stats/programme-service.service.ts